import {FC, useState} from 'react'
import {numberWithCommas} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getInvoicePatternValidationError} from '../core/invoicePatternValidation'
import {
  InvoiceEmptyState,
  InvoiceSectionHeader,
} from '../invoice-edit-modal/components/InvoicePresentation'
import {CodelessUnitRowsNotice} from '../invoice-edit-modal/components/CodelessUnitRowsNotice'

type props = {
  items: any[]
  setEditInvoiceItem?: any
  invoiceTemplate?: number
}

const InvoiceSimpleFormItemTable: FC<props> = ({
  items,
  setEditInvoiceItem,
  invoiceTemplate = 1,
}) => {
  const {variableD} = useListView()
  const [key_, setKey_] = useState(1)
  const patternValidationError = getInvoicePatternValidationError(invoiceTemplate, items)
  const canAddInvoiceItem = !(invoiceTemplate == 14 && items.length >= 1)
  return (
    <section className='mp-invoice-section mp-invoice-section--compact'>
      <InvoiceSectionHeader
        title='اقلام صورتحساب'
        helpKey='section.body'
        description='شرح، مقدار و مبلغ نهایی هر قلم در نمای اصلی نمایش داده می‌شود.'
        eyebrow={`${numberWithCommas(items.length)} ردیف`}
        actions={
          setEditInvoiceItem && variableD != 4 && variableD != 2 ? (
            <button
              type='button'
              className={`btn btn-sm ${canAddInvoiceItem ? 'btn-primary' : 'btn-light-secondary'}`}
              disabled={!canAddInvoiceItem}
              onClick={() => {
                if (canAddInvoiceItem) {
                  setEditInvoiceItem(null)
                  setKey_(key_ + 1)
                }
              }}
            >
              <i className='las la-plus' aria-hidden='true'></i>
              {canAddInvoiceItem ? 'افزودن قلم' : 'الگوی ۱۴ فقط یک ردیف دارد'}
            </button>
          ) : undefined
        }
      />
      {patternValidationError != '' && (
        <div className='alert alert-danger d-flex align-items-center p-4 mb-4'>
          <i className='las la-exclamation-triangle fs-2x text-danger me-3'></i>
          <div className='fw-bold'>{patternValidationError}</div>
        </div>
      )}
      <CodelessUnitRowsNotice items={items} />
      <div className='mp-invoice-data-table-wrap'>
        <table className='table mp-invoice-data-table mp-invoice-simple-items'>
          <thead>
            <tr>
              <th className='text-start'>کالا یا خدمت</th>
              <th className='text-center'>تعداد یا مقدار</th>
              <th className='text-center'>مبلغ نهایی</th>
            </tr>
          </thead>
          <tbody key={`tbl_${key_}-${items.length}`}>
            {items.map((rw, ind) => (
              <tr
                className={`mp-invoice-data-row${setEditInvoiceItem ? ' is-actionable' : ''}`}
                key={`tableRow_${ind}`}
                onClick={() => setEditInvoiceItem && setEditInvoiceItem(rw)}
              >
                <td data-label='کالا یا خدمت' className='mp-invoice-cell--item text-start'>
                  <strong className='mp-invoice-item-title'>
                    {rw.description || rw.product?.nm || 'بدون شرح'}
                  </strong>
                  {!!rw.discount && (
                    <small className='text-success'>
                      تخفیف: {numberWithCommas(rw.discount)} ریال
                    </small>
                  )}
                </td>
                <td data-label='تعداد یا مقدار' className='mp-invoice-cell--number text-center'>
                  <b>{numberWithCommas(rw.qty)}</b>
                  <small>{rw.vatRate == 0 ? 'معاف از مالیات' : `مالیات ${rw.vatRate}٪`}</small>
                </td>
                <td data-label='مبلغ نهایی' className='mp-invoice-cell--final text-center'>
                  <b>{numberWithCommas(rw.netPrice)}</b>
                  <small>ریال</small>
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr className='mp-invoice-data-empty-row'>
                <td colSpan={3}>
                  <InvoiceEmptyState
                    title='هنوز قلمی ثبت نشده است'
                    description='برای تکمیل صورتحساب، اولین کالا یا خدمت را اضافه کنید.'
                    icon='la-box-open'
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  )
}

export {InvoiceSimpleFormItemTable}
